/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Account status
 */
export type GetUserAccountsForAppResponseDataItemStatus = typeof GetUserAccountsForAppResponseDataItemStatus[keyof typeof GetUserAccountsForAppResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserAccountsForAppResponseDataItemStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
